module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.shown = 'client'
      }
    }
  }, [_vm._v("Client")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.shown = 'contractor'
      }
    }
  }, [_vm._v("Contractor")]), _vm._v(" "), (_vm.shown == 'contractor') ? _c('div', [_c('h3', [_vm._v("Contractor Projects")]), _vm._v(" "), _vm._l((_vm.contractor_projects), function(project) {
    return _c('p', [_c('router-link', {
      attrs: {
        "to": {
          path: 'projects/' + project.id
        }
      }
    }, [_vm._v(_vm._s(project.title))])], 1)
  }), _vm._v(" "), (_vm.contractor_projects.length == 0) ? _c('div', [_c('loading')], 1) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.shown == 'client') ? _c('div', [_c('h3', [_vm._v("Client Projects")]), _vm._v(" "), _vm._l((_vm.client_projects), function(project) {
    return _c('p', [_c('router-link', {
      attrs: {
        "to": {
          path: 'projects/' + project.id
        }
      }
    }, [_vm._v(_vm._s(project.title))])], 1)
  }), _vm._v(" "), (_vm.client_projects.length == 0) ? _c('div', [_c('loading')], 1) : _vm._e()], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-3e89f0b4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Projects.vue
// module id = 127
// module chunks = 1